/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22.8 10.125H1.2c-.663 0-1.2.531-1.2 1.188 0 .656.537 1.187 1.2 1.187h1.2v4.75C2.4 19.873 4.55 22 7.2 22h9.6c2.65 0 4.8-2.127 4.8-4.75V12.5h1.2c.662 0 1.2-.531 1.2-1.188 0-.656-.538-1.187-1.2-1.187M18 5.375h-2.1C15.9 4.063 14.825 3 13.5 3h-3C9.175 3 8.1 4.063 8.1 5.375H6c-1.988 0-3.6 1.595-3.6 3.563h19.2c0-1.968-1.612-3.563-3.6-3.563"
}), 'CategoryUD');